import React from 'react';

const STATUS_STYLES = {
  new: { bg: '#E0F2FE', text: '#0369A1' },
  contacted: { bg: '#FEF9C3', text: '#A16207' },
  needs_follow_up: { bg: '#FFF7ED', text: '#C2410C' },
  replied: { bg: '#DCFCE7', text: '#166534' },
  closed: { bg: '#FEE2E2', text: '#991B1B' },
  not_contacted: { bg: '#E2E8F0', text: '#334155' },
  queued: { bg: '#DBEAFE', text: '#1D4ED8' },
  qualified: { bg: '#FEF3C7', text: '#92400E' },
  meeting_booked: { bg: '#D1FAE5', text: '#065F46' },
  won: { bg: '#DCFCE7', text: '#166534' },
  lost: { bg: '#FEE2E2', text: '#991B1B' },
  do_not_contact: { bg: '#F3E8FF', text: '#6B21A8' },
};

export default function LeadStatusBadge({ status }) {
  const style = STATUS_STYLES[status] || { bg: '#F3F4F6', text: '#374151' };
  return (
    <span
      className="px-3 py-1 rounded-full text-sm font-medium"
      style={{ backgroundColor: style.bg, color: style.text }}
    >
      {status.replace('_', ' ')}
    </span>
  );
}
